/* eslint-disable react/prop-types */
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import ComplexStatisticsCard from "../../../../components_reefer/Cards/StatisticsCards/ComplexStatisticsCard";
import MDBox from "../../../../components/MDBox";

// patios: lista já filtrada (somente pátios exibidos no dashboard)
function OrdersOverview({ patios }) {
  const { t } = useTranslation("common");

  const totals = patios.reduce(
    (acc, p) => ({
      cont: acc.cont + p.containersComplete.length,
      monit: acc.monit + p.containersMonitored.length,
      err: acc.err + p.monitUniqueErr,
    }),
    { cont: 0, monit: 0, err: 0 }
  );

  return (
    <MDBox pt={1} pb={3}>
      <Grid container spacing={4} px={2}>
        <Grid item xs={12}>
          <ComplexStatisticsCard
            icon="fitbit"
            color="info"
            Err={t("dashboard.dash_contPatios")}
            title={`${totals.cont}`}
          />
        </Grid>
        <Grid item xs={12}>
          <ComplexStatisticsCard
            icon="checkbox"
            color="success"
            Err={t("dashboard.dash_contMonit")}
            title={`${totals.monit}`}
          />
        </Grid>
        <Grid item xs={12}>
          <ComplexStatisticsCard
            icon="error"
            color="primary"
            Err={t("dashboard.dash_errs")}
            title={`${totals.err}`}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default OrdersOverview;
